import { type RefObject, useEffect, useState } from 'react';
import { useEventListener } from 'usehooks-ts';
import { useConfigurationStore } from '@/stores/configuration';

/**
 * 用於檢查文字內容是否被截斷
 * @param {React.RefObject<HTMLElement>} ref - 綁定內容元素的參考
 * @returns {object}
 *   - messageLineClamp {number}: 行數限制
 *   - isContentClamped {boolean}: 是否被截斷的狀態
 */
function useContentClamp(ref: RefObject<HTMLElement>) {
  const messageLineClamp = useConfigurationStore((s) => s.envConfig.config?.messageLineClamp ?? 3);
  const [isContentClamped, setIsContentClamped] = useState(false);

  const checkClamping = () => {
    if (ref.current) {
      const { scrollHeight, clientHeight } = ref.current;
      setIsContentClamped(scrollHeight > clientHeight);
    }
  };

  useEventListener('resize', checkClamping);

  useEffect(() => {
    checkClamping();
  }, []);

  return {
    messageLineClamp,
    isContentClamped,
  };
}

export default useContentClamp;
